import { render, staticRenderFns } from "./CrimeDisclaimer.vue?vue&type=template&id=7e921335&scoped=true&"
import script from "./CrimeDisclaimer.vue?vue&type=script&lang=js&"
export * from "./CrimeDisclaimer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e921335",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e921335')) {
      api.createRecord('7e921335', component.options)
    } else {
      api.reload('7e921335', component.options)
    }
    module.hot.accept("./CrimeDisclaimer.vue?vue&type=template&id=7e921335&scoped=true&", function () {
      api.rerender('7e921335', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/screen/components/Print/CrimeDisclaimer.vue"
export default component.exports